export enum TeamSortValues {
    NAME = 'name',
    HEADLINE = 'headline',
    LAST_ACTIVITY = 'last_activity',
    TOTAL_TIME = 'learning_time',
    ACTIONS_TO_PROCESS = 'actions'
}